<template>
  <div>
    <h1 class="common__main-title">Tutor List</h1>
    <div>
      <Search
        @search="changeConditions"
        ref="search"
        class="mb-4"
      />
      <div class="d-flex justify-content-between mb-4">
        <div class="d-flex align-items-center">
          <select class="form-control mr-2" v-model="selectedYear">
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
          <div>
            <b-button
              pill
              variant="primary"
              @click="outputContract"
            >
              Download
            </b-button>
          </div>
        </div>
        <div class="d-flex">
          <b-button
            pill
            variant="primary"
            :to="{name:'TutorAdd'}"
            class="mr-2"
          >
            Add
          </b-button>
          <b-button
            pill
            variant="primary"
            :to="{name:'BulkUpdate'}"
          >
            Bulk Edit
          </b-button>
        </div>
      </div>
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="fetchTutors" class="mb-2" />
      </div>
      <TutorTable :tutors="tutors" :pager="pager" :conditions="conditions" ref="tutor"/>
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="fetchTutors" />
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator'
import { RootState } from '@/store/types';
import { Tutor, TutorConditions } from '@/store/tutors/types';
import PagerComponent from '@/components/parts/Pager.vue';
import TutorTable from '@/components/parts/tutor/TutorTable.vue';
import Search, { TutorSearchConditions } from '@/components/parts/tutor/TutorSearch.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import { Sort } from '@/store/sort.types';
import { Pager } from '@/store/pager.types';
import moment from 'moment'
// @ts-expect-error 型チェック不要部分
import FileSaver from 'file-saver'

@Component({
  components: {
    Search,
    PagerComponent,
    TutorTable,
    Loading,
  },
})
export default class TutorsComponent extends Vue {
    isLoading: boolean = false

    conditions: TutorSearchConditions|null = null

    private selectedYear: number = moment().year()

    private years: number[] = (() => {
      const startYear = 2020
      const endYear = moment().year() + 1
      return _.range(startYear, endYear + 1)
    })()

    private get tutors(): Tutor[] {
      return (this.$store.state as RootState).tutors.tutors
    }

    private get pager(): Pager {
      return (this.$store.state as RootState).tutors.pager
    }

    private get sort(): Sort|undefined {
      return (this.$store.state as RootState).tutors.sort
    }

    created() {
      this.fetchTutors(1)
    }

    private changeConditions(searchConditions: TutorSearchConditions) {
      this.conditions = searchConditions
      this.fetchTutors(1)
    }

    private fetchTutors(page: number = 1) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      const conditions: TutorConditions = _.pickBy({
        tutorNameOrId: this.conditions?.tutorNameOrId,
        positions: this.conditions?.positions,
        nationality: this.conditions?.nationality,
        isIncludeTerminationOfService: this.conditions?.isIncludeTerminationOfService,
        genderCodes: this.conditions?.genderCodes,
      })

      this.$store.dispatch('fetchTutors', {
        conditions,
        page,
        sortBy: this.sort,
      }).finally(() => {
        this.isLoading = false;
      })
    }

    private async outputContract() {
      this.isLoading = true;
      try {
        const { content, filename } = await this.$store.dispatch('exportTutorContractByCsv', {
          selectedTutorIds: (this.$refs.tutor as TutorTable).selectedTutorIds,
          selectedYear: this.selectedYear,
        })
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        FileSaver.saveAs(blob, filename);
        this.isLoading = false;
      } catch (error: any) {
        this.isLoading = false;
        const message = _.has(error, 'response') ? error.response.data.message : error.message;
        this.$bvModal.msgBoxOk(`Error - ${message}`)
      }
    }
}
</script>
